<template>
  <div class="card_detail" @click="$parent.cardShow = false">
    <div class="card_box">
      <div class="title_box">{{ card.name }}</div>
      <div class="info_box">
        <div class="info_text">
          <span>镶嵌部位：{{ type }}</span>
          <span>使用等级：1</span>
        </div>
        <div class="card_img">
          <i :class="`icon ${card.type}`"></i>
          <i class="border"></i>
          <img
            :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${card.img}.png`"
            alt=""
          />
        </div>
      </div>
      <div class="data_box">
        <span>卡片效果</span>
        <span v-html="descText(card.desc)"></span>
      </div>
      <div class="b_btn" v-if="btnType" @click="moveBag">{{ btnType }}</div>
    </div>
  </div>
</template>

<script>
import { putinbag } from '../api/index';
export default {
  components: {},
  props: ['card'],
  data() {
    return {
      btnType: '', //操作类型 存入 取至
      cardTypeIndex: null //当前卡片所在数组(storeList\myList)的index,防止重复卡片影响顺序
    };
  },
  computed: {
    type: function () {
      let text;
      switch (this.card.type) {
        case 'armor':
          text = '衣服';
          break;
        case 'shawl':
          text = '披风';
          break;
        case 'accessory':
          text = '饰品';
          break;
        case 'headwear':
          text = '头饰';
          break;
        case 'weapon':
          text = '武器';
          break;
        case 'shoes':
          text = '鞋子';
          break;
      }
      return text;
    }
  },
  filters: {},
  watch: {},
  methods: {
    moveBag() {
      if (this.btnType == '取至背包') {
        if (
          !this.$parent.myList[0]?.name ||
          (this.$parent.myList.length == 2 && !this.$parent.myList[1]?.name)
        ) {
          //第一个格子为空 或 第二格子为空 才可操作
          putinbag({
            ids: this.$parent.storeList[this.cardTypeIndex].id,
            type: 1
          }).then((res) => {
            if (res.data.data.code == 0) {
              //加入背包
              if (this.$parent.myList[0]?.name) {
                //是否有第一张卡片 若有则插入第二张
                this.$parent.myList[1] =
                  this.$parent.storeList[this.cardTypeIndex];
              } else {
                this.$parent.myList[0] =
                  this.$parent.storeList[this.cardTypeIndex];
              }
              this.$parent.storeList.splice(this.cardTypeIndex, 1); //从仓库删除
            } else {
              this.$parent.getTip(`取至背包失败--code:${res.data.data.code}`);
            }
          });
        } else {
          this.$parent.getTip(`背包已满`);
        }
      } else {
        putinbag({
          ids: this.$parent.myList[this.cardTypeIndex].id,
          type: 2
        }).then((res) => {
          if (res.data.data.code == 0) {
            //存入仓库
            this.$parent.storeList.push(
              this.$parent.myList[this.cardTypeIndex]
            );
            this.$parent.myList.splice(this.cardTypeIndex, 1); //从背包取出删除
            this.$parent.myList.push({}); //插入空格子
          } else {
            this.$parent.getTip(`存入仓库失败--code:${res.data.data.code}`);
          }
        });
      }
    },
    descText(val) {
      return val.replace('，', '<br>');
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.card_detail {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  span {
    font-family: 'SourceHanSerifCNBold';
  }
  .card_box {
    width: 3.46rem;
    height: 5.08rem;
    background: url('../assets/img/pc/pop/card_pop.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title_box {
      width: 100%;
      height: 0.62rem;
      font-weight: 800;
      font-size: 0.28rem;
      color: #242c36;
      font-family: 'SourceHanSerifCNBold';
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.16rem;
    }
    .info_box {
      width: 2.82rem;
      height: 1.31rem;
      margin-top: 0.28rem;
      display: flex;
      justify-content: space-between;
      .info_text {
        display: flex;
        flex-direction: column;
        span {
          font-size: 0.2rem;
          color: #2e2925;
        }
      }
      .card_img {
        width: 1.04rem;
        height: 1.31rem;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .border {
          width: 1.04rem;
          height: 1.31rem;
          background: url('../assets/img/pc/pop/card_quality_1.png');
          background-size: 100% 100%;
          position: absolute;
        }
        .icon {
          width: 0.12rem;
          height: 0.12rem;
          position: absolute;
          top: 0.04rem;
          left: 0.04rem;
          z-index: 2;
        }
        .accessory {
          background: url('../assets/img/pc/pop/accessory.png');
          background-size: 100% 100%;
        }
        .armor {
          background: url('../assets/img/pc/pop/armor.png');
          background-size: 100% 100%;
        }
        .headwear {
          background: url('../assets/img/pc/pop/headwear.png');
          background-size: 100% 100%;
        }
        .shawl {
          background: url('../assets/img/pc/pop/shawl.png');
          background-size: 100% 100%;
        }
        .shoes {
          background: url('../assets/img/pc/pop/shoes.png');
          background-size: 100% 100%;
        }
        .weapon {
          background: url('../assets/img/pc/pop/weapon.png');
          background-size: 100% 100%;
        }
      }
    }
    .data_box {
      width: 2.82rem;
      display: flex;
      flex-direction: column;
      margin-top: 0.5rem;
      span {
        font-weight: bold;
        font-size: 0.2rem;
        color: #2e2925;
      }
      span:last-child {
        font-weight: normal;
      }
    }
    .b_btn {
      width: 1.63rem;
      height: 0.5rem;
      background: url('../assets/img/pc/pop/store_btn.png');
      background-size: 100% 100%;
      position: absolute;
      bottom: 0.45rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.24rem;
      color: #64340b;
      font-family: 'SourceHanSerifCNBold';
      cursor: pointer;
    }
  }
}
</style>